import React from 'react';
import './Choosepet.css';
import Choose from '../../../imgs/Choose.webp';

const Choosepet = () => {
    return (
        <div className="Cavity-container">
            <div className='Cavitys'>
                <h2 className="Cavity-title">How To Choose PET Preform Injection Molding Machine</h2>
                <p className="Cavity-date">Jul 13, 2022</p>

                <div className="Cavity">
                    <img src={Choose} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                    <div className="Cavity-content">

                        <p className="Cavity-text">
                            Are you planning to add a new preform production line or start a new business in the PET preform sector? Do you know how to choose the right PET preform equipment model for your project?
                        </p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Choosepet;
